// -- other --
import React,{useState,useEffect,useRef} from "react";
import {Link,useNavigate} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../../../core/img";
import {all_routes} from "../../../router/all_routes";
import Table from "../../../../core/dataTable/index";
import {Toaster} from 'react-hot-toast';
/* -- biz9 -- */
import {UrlQuery} from "biz9-react-utility";
import {Message,Type,Url,Field,Title} from "../../../../constant";
import {App,Toast_Message,Data,Dashboard,Event,Image,Style,Service_Industry,User,Template,Storage,System} from "../../../../project";
import {Data_Logic} from "biz9-data-app";
import {Stat_Table} from "biz9-stat";
import {Image_Format} from "biz9-image";
import {User_Table,User_Field} from "biz9-user";
import {Portal_Value_Type,Portal_Field,Portal_Url,Portal_Table,Portal_Remote_Data,Portal_Type} from "biz9-portal-app";
import {Log,Str,DateTime} from "biz9-utility";

const Dashboard_Admin_User = () => {
    const query = UrlQuery();
    const navigate = useNavigate();
    const timeoutRef = useRef(null);
    const [val_id,setValId] = useState(query.get('id'));
    const [user,setUser] = useState(Data_Logic.get(Portal_Table.USER,0));
	const [val_sub_page_title,setValSubPageTitle] = useState("Users");
    const [val_search,setValSearch] = useState("");
    const [stop_search,setStopSearch] = useState('');
    const [users,setUsers] = useState([]);
    // -- paging --
    const [val_page_current,setValPageCurrent] = useState(Type.PAGE_CURRENT);
    const [val_page_size,setValPageSize] = useState(Type.PAGE_SIZE);
    const [val_total,setValTotal] = useState(0);
    const [val_filter,setValFilter] = useState({});
    const [val_sort_by,setValSortBy] = useState({});
    const [val_option,setValOption] = useState({});

    const columns = [
    {
title: "UserName",
           dataIndex: "username",
           render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.id} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.id} className="text-dark">
                   {record.username}
                   </Link>
                  </h2>
                   ),
           sorter: false
    },

    {
title: "Name",
       dataIndex: "name",
       render: (text: string, record: any) => (
               <>
               {record.first_name}{" "}
               {record.last_name}
               </>
               ),
       sorter: false
    },
     {
title: "E-mail",
       dataIndex: "email",
       render: (text: string, record: any) => (
               <>
               {record.email}
               </>
               ),
       sorter: false
    },
    {
title: "Role",
       dataIndex: "role",
       render: (text: string, record: any) => (
               <>
               {Str.get_table_by_name(record.role)}
               </>
               ),
       sorter: false
    },
 {
title: "Last Login",
       dataIndex: "last_login",
       render: (text: string, record: any) => (
               <>
               { !Str.check_is_null(record.stat_user.date_create) ? DateTime.get_date_time(record.stat_user.date_create) : 'n/a'}
               </>
               ),
                sorter: false
    },
    {
title: "Gender",
       dataIndex: "gender",
       render: (text: string, record: any) => (
               <>
               {record.gender}
               </>
               ),
       sorter: false
    },
    ];
    useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        Storage.post_dashboard_side_bar(Title.USER_SIDE_BAR_USER);
		get_data();
	    if(timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
   	},[]);
    async function get_data() {
         let foreign_stat_last_login = Data_Logic.get_foreign(Portal_Value_Type.ONE,Portal_Table.STAT,Portal_Field.USER_ID,Portal_Field.ID,{title:'stat_user',sort_by:{date_create:-1}});
        let option = {foreigns:[foreign_stat_last_login],field:{id:1,username:1,email:1,role:1,gender:1,image_filename:1,first_name:1,last_name:1}};
       let search = Data_Logic.get_search(Portal_Table.USER,{});
        const [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search,option);
        setUsers(data.items);
       Toast_Message.dismiss();
    };
    const post_search = (e) => {
        const value = e.target.value;
        setValSearch(value);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
                setStopSearch(value);
                let filter = {};
                if(value){
                filter = {
                $or: [
                {username:{ $regex:String(val_search),$options:"i"}},
                {first_name:{$regex:String(val_search),$options:"i"}},
                {last_name:{$regex:String(val_search),$options:"i"}},
                {email:{$regex:String(val_search),$options:"i"}}
                ]};
                }
                let search = Data_Logic.get_search(Portal_Table.USER,filter);
                               post_search_data(search);
                }, 500);
    };
      async function post_search_data(search) {
        // -- get-search-items --
        Toast_Message.loading(Message.SEARCHING);
        let foreign_stat_last_login = Data_Logic.get_foreign(Portal_Value_Type.ONE,Portal_Table.STAT,Portal_Field.USER_ID,Portal_Field.ID,{title:'stat_user',sort_by:{date_create:-1}});
        let option = {foreigns:[foreign_stat_last_login],field:{id:1,username:1,email:1,role:1,gender:1,image_filename:1,first_name:1,last_name:1}};
        const [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search,option);
        setUsers(data[Portal_Type.ITEMS]);
        setValTotal(data[Portal_Type.ITEM_COUNT]);
        Toast_Message.dismiss();
    };
  return (
            <>
 <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="container px-0">
            {/*Inner Content */}
            <div className="content mx-4 mb-4">
            <div className="main-title my-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            <div className="wallet-wrap">
            <div className="wallet-list">
            <div className="wallet-item mt-10">
            <div  className="pt-10">
            <input type='text' autoComplete='off' className='form-control' placeholder={"Search "+ Str.get_table_by_name(Portal_Table.USER,{plural:true})} value={val_search} onChange={post_search}/>
            </div>
            </div>
            </div>
            </div>
            <div className="table-responsive custom-table">
 <Table onUpdate={setUsers} allow_multiple={true}  page_size={val_page_size} page_current={val_page_current} total={val_total} option={val_option} sort_by={val_sort_by} filter={val_filter} table={Portal_Table.USER} dataSource={users} columns={columns} Selection={false} />
            </div>
            <div className="table-footer">
            <div id="tablepage" />
            </div>
            </div>
            {/* /Inner Content */}
    </div>
        </div>
        {/* /Page Content */}
    </>
        );
};
export default Dashboard_Admin_User;
